export enum enmPasswordResetType {
    Email = 0,
    UserName = 1,
    Unknown = 2
}